import clsx from "clsx";

import {
  Column,
  ColumnOptions,
  ColumnType,
  DataTable,
  SortDirection,
} from "@transfr-inc/dashboard-components/data-table";

import "./device.app-table.scss";

export function DeviceAppsTable({ data, responsiveStyles }) {
  const columns = [
    new Column(
      "title",
      "APP",
      ColumnType.BASIC,
      new ColumnOptions({ sortingEnabled: true })
    ),
    new Column(
      "versionName",
      "Version",
      ColumnType.BASIC,
      new ColumnOptions({ sortingEnabled: true })
    ),
  ];

  return (
    <DataTable
      className={clsx("device-apps-table", responsiveStyles)}
      columns={columns}
      data={data}
      keyFields={["title"]}
      defaultSortPropName={"title"}
      defaultSortDirection={SortDirection.ASCENDING}
      responsiveStyles={responsiveStyles}
      rowHeightConfig={{ large: 54 }}
    />
  );
}
